import React, { useState } from "react";
import { useUploadContext } from "../../contexts/UploadContext.js";
import useDragAndDrop from "../../hooks/UseDragAndDrop.js";

const DragAndDropUpload = ({ commonData }) => {
  const { uploadData, updateUploadData } = useUploadContext();
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileDrop = (files) => {
    // const newEntries = files.map((file) => ({
    //   fileName: file.name,
    //   file, // 將檔案物件存入
    //   access: "", // 初始為空，submit 時再更新
    //   client: "",
    //   project: "",
    // }));
    // updateUploadData(newEntries); // 將新檔案加入 context
    const newEntries = files.map((file) => ({
      fileName: file.name,
      file, // 儲存檔案物件
      ...commonData, // 即時同步表單資料
    }));
    updateUploadData(newEntries); // 更新 Context，覆蓋舊檔案
    console.log(uploadData);
  };

  const { isDragging, handleDragOver, handleDragLeave, handleDrop } = useDragAndDrop(handleFileDrop);

  return (
    <div
      className={`app ${isDragging ? "dragging" : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {/* <div
      style={{
        border: "2px dashed #007bff",
        borderRadius: "5px",
        padding: "20px",
        textAlign: "center",
        backgroundColor: "#f8f9fa",
        color: "black",
      }}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
    > */}
      <div>拖拉檔案到這裡</div>
      <div>或點擊下方按鈕選擇檔案</div>
      <input
        type="file"
        multiple
        // webkitdirectory="true"
        // directory="true"
        onChange={(e) => handleFileDrop(Array.from(e.target.files))}
        style={{ display: "none" }}
        id="fileInput"
      />
      <label
        htmlFor="fileInput"
        className="file-button"
      >
        選擇檔案
        <img src='./arrow04.png' style={{
          width: "20%",
        }}></img>

      </label>
      {/* {uploadedFiles.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <div>已選擇檔案:</div>
          <ul>
            {uploadData.files.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>

          <ul>
            {uploadedFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>

        </div>
      )} */}
      {/* </div> */}
    </div>
  );
};

export default DragAndDropUpload;
